<template>
	<div>
		<div v-if="title" class="font-weight-bold mb-2">{{ title }}</div>

		<div v-if="grantsEverything" class="text-body-2 text-grey-darken-1">
			Administrator skips every permission check, so this grants full access.
		</div>

		<div
			v-else-if="!sortedPermissions.length"
			class="text-body-2 text-grey-darken-1"
		>
			{{ emptyText }}
		</div>

		<ul v-else-if="columns" class="d-flex flex-column ga-2 ma-0 pl-5">
			<li v-for="permission of sortedPermissions" :key="permission.id">
				<div class="permission-grant-row">
					<span class="font-weight-bold permission-grant-name">
						{{ permission.name }}
					</span>
					<span class="text-body-2 text-grey-darken-1">
						{{ permission.description }}
					</span>
				</div>
			</li>
		</ul>

		<div v-else class="d-flex flex-column ga-2">
			<div
				v-for="permission of sortedPermissions"
				:key="permission.id"
				class="d-flex flex-column"
			>
				<span class="font-weight-bold permission-grant-name">
					{{ permission.name }}
				</span>
				<span
					v-if="permission.description"
					class="text-body-2 text-grey-darken-1"
				>
					{{ permission.description }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
// What a set of permissions unlocks, one entry per permission with its
// description, so whoever grants access sees it before saving. Used by the
// role editor, the user editor and the Access levels dialog.
export default {
	name: "PermissionGrantList",

	props: {
		// Name and description side by side, so the list does not read like
		// the stacked role header above it (the Access levels dialog).
		columns: Boolean,
		emptyText: { type: String, default: "No permissions." },
		// Administrator bypasses every can: check (middleware/Can.ts), so its
		// handful of explicit grants would understate it.
		grantsEverything: Boolean,
		permissions: { type: Array, default: () => [] },
		title: { type: String, default: "" },
	},

	computed: {
		sortedPermissions() {
			return [...this.permissions].sort((a, b) => a.name.localeCompare(b.name));
		},
	},
};
</script>

<style scoped lang="scss">
// The description's size (text-body-2), so the name does not outgrow the
// role name above it inside a v-card-text. Set here because a text-* class
// would force the weight back to 400 (scss/variables.scss).
.permission-grant-name {
	font-size: 0.875rem;
	letter-spacing: normal;
	line-height: 1.4;
}

// Fixed name column, so the descriptions line up across every role.
.permission-grant-row {
	display: grid;
	grid-template-columns: 13rem 1fr;
	align-items: baseline;
	column-gap: 16px;
}
</style>
